import { render, staticRenderFns } from "./FreeList.vue?vue&type=template&id=e37892d8&scoped=true"
import script from "./FreeList.vue?vue&type=script&lang=js"
export * from "./FreeList.vue?vue&type=script&lang=js"
import style0 from "./FreeList.vue?vue&type=style&index=0&id=e37892d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37892d8",
  null
  
)

export default component.exports